module.exports = __webpack_public_path__ + "media/tiu.d4335816.mp4";